import React from "react";
import { Link, useParams } from "react-router-dom";

const LogoEchoSystem = ({ tenantUsername }) => {
  const _token = localStorage.getItem("token");

  console.log(tenantUsername);

  return (
    <Link
      to={`${process.env.REACT_APP_WEB_APPS_BASE_URL}/${tenantUsername}/token/${_token}`}
    >
      <div className="flex-1 flex justify-center items-center">
        <img
          src={`/logo-white.webp`}
          className="w-24 hover:opacity-50"
          title="Back to ABSAT applications"
          alt="Back to ABSAT applications"
        />
      </div>
    </Link>
  );
};
export default LogoEchoSystem;
